import { render, staticRenderFns } from "./tAdmin.vue?vue&type=template&id=69820498"
import script from "./tAdmin.vue?vue&type=script&lang=js"
export * from "./tAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports